import React from 'react';

export default function WelcomeWave({ size = 30, color = '#3b82f6' }) {
  const bounce = Math.round(size * 0.65);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: size * 0.65,
      }}
    >
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: color,
            animation: 'welcome-wave-bounce 0.6s ease-in-out infinite',
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}

      <style>{`
        @keyframes welcome-wave-bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-${bounce}px);
          }
        }
      `}</style>
    </div>
  );
}
